module.exports = __webpack_public_path__ + "img/img_a@2x.2a37f102.png";